import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { parseLocaleDatetime } from "common/util";
import { View, Text } from "react-native";




export interface AzMgmtData {
    availability_zone_id: string,
    availability_zone_name: string,
    availability_zone_active_yn: boolean,
    create_ts: string,
    update_ts: string,
    host_count: number,
    host_cluster_count: number,
    region: {
      region_id: string
      region_name: string
    }
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "REGION_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("AZ_NAME_TEXT"),
        accessor: "availability_zone_name",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: "20px"
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value}</div>)
    },
    {
        Header: i18n.t("AZ_STATE_TEXT"),
        accessor: "availability_zone_active_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value
                    ?
                        <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                            <StatusStableImg style={className.statusImg}/>
                            <Text style={{lineHeight: 12, fontSize: 12, alignSelf: 'center'}}>Up</Text>
                        </View>
                    :
                        <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                            <StatusBlockImg style={className.statusImg}/>
                            <Text style={{lineHeight: 12, fontSize: 12, alignSelf: 'center'}}>Down</Text>
                        </View>
                }

            </div>
        )
    },
    {
        Header: i18n.t("AZ_HOST_CLUSTER_COUNT_TEXT"),
        accessor: "host_cluster_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{value}{i18n.t("UNIT_TEXT")}</div>
        )
    },
    {
        Header: i18n.t("AZ_HOST_COUNT_TEXT"),
        accessor: "host_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{value}{i18n.t("UNIT_TEXT")}</div>
        )
    },
    {
        Header: i18n.t("REGION_TEXT"),
        accessor: "region.region_name",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
];

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}